<template>
    <div class="tabs-wrap">
      <div class="tab-navs">
        <div class="tab-navs-inner" :class="[tabClass]">
          <div class="tab-item clickable" :class="{'active': n.name == currTab}" v-for="n of navList" :key="n.name" @click="activeTab(n)">
            <span class="tab-text">{{n.label}}</span>
            <span class="tab-mark"></span>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <slot></slot>
      </div>
    </div>
</template>

<script>
/**@augments filters 数组，结构如下
 */
export default {
  name: 'Tabs',
  props: [],
  data () {
    return {
      currTab: '',
      navList:[],
      tabClass: ''
    }
  },
  computed: {
    
  },
  mounted(){
    this.updateNav();
  },
  methods: {
    getTabs () {
        this.$nextTick(()=>{
          var clientW = this.$el.getElementsByClassName("tab-navs")[0].clientWidth;
          var innerW = this.$el.getElementsByClassName("tab-navs-inner")[0].clientWidth;
          var size = this.$el.getElementsByClassName("tab-item").length;
          if(innerW < clientW){
            this.tabClass = 'size-'+size;
          }
        });
        return this.$children.filter(item => item.$options.name === 'TabPane');
    },
    updateNav(){
      this.navList = [];
      this.getTabs().forEach((pane, index) => {
          this.navList.push({
              labelType: typeof pane.label,
              label: pane.label,
              name: pane.currentName || index
          });
      });
      if(this.navList.length > 0){
        this.activeTab(this.navList[0]);
      }
      
    },
    activeTab(tab){
      this.currTab = tab.name;
      const tabs = this.getTabs();
      tabs.forEach(tab => tab.show = (tab.currentName === this.currTab));

      this.$emit("tab-active", [tab.name]);
    }
  }
}
</script>

<style lang="less" scoped>

.tabs-wrap{

  .tab-navs{
    overflow: auto;
    white-space: nowrap;
    box-sizing: border-box;

    .tab-navs-inner{
      float: left;
      border-bottom: 1px solid #ddd;
      text-align: center;
      width: 100vw;

      &.size-2{

        .tab-item{
          width: 30vw;
        }
        
      }

      &.size-3{

        .tab-item{
          width: 33.333vw;
        }
        
      }

      &.size-4{

        .tab-item{
          width: 25vw;
        }
        
      }

      &.size-5{

        .tab-item{
          width: 20vw;
        }
        
      }

    }

    .tab-item{
      display: inline-block;
      

      .tab-text{
        display: block;
        padding: 3vw 4vw;
        font-size: 4vw;
        color: #666;
      }

      .tab-mark{
        background: transparent;
        display: block;
        height: .5vw;
        width: 12vw;
        margin: 0 auto;
      }

      &.active{
        .tab-text{
          color: @themeColor;
        }
        .tab-mark{
          background: @themeColor;
        }
      }
    }
  }
}

</style>





// WEBPACK FOOTER //
// src/components/common/Tabs.vue